import { getCurrentTimezone } from './get-current-timezone'

export function getDateBounds(
  dateTimeString: string,
  timezone: number,
): { start: Date; end: Date } {
  const date = new Date(dateTimeString)
  const utcTime = date.getTime()
  const targetTime = utcTime + timezone * 60 * 60 * 1000
  const targetDate = new Date(targetTime)
  const year = targetDate.getUTCFullYear()
  const month = targetDate.getUTCMonth()
  const day = targetDate.getUTCDate()

  const start = new Date(Date.UTC(year, month, day) - timezone * 60 * 60 * 1000)
  const end = new Date(
    Date.UTC(year, month, day + 1) - timezone * 60 * 60 * 1000 - 1,
  )

  return { start, end }
}

export function convertToStartOfDay(dateTimeString: string) {
  const timezone = getCurrentTimezone()
  const { start } = getDateBounds(dateTimeString, timezone)
  return start.toISOString()
}

export function convertToEndOfDay(dateTimeString: string) {
  const timezone = getCurrentTimezone()
  const { end } = getDateBounds(dateTimeString, timezone)
  return end.toISOString()
}
